import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { Container, Row } from "reactstrap";
import DataReactTable from "@/containers/Tables/DataTable/components/DataReactTable";
import AddModal from "@/shared/components/AddModal";
import Modal from "@/shared/components/Modal";
import {
  useLazyGetRecordsQuery,
  useDeleteMutation,
} from "@/services/pcApi";
import { APPLICATION_SCREEN_TAG } from "@/shared/tagFile";
import { successToast } from "@/shared/components/toast";
import { formateColumnFilter } from "@/utils/columnFilter";
import ApplicationScreenForm from "./ApplicationScreenForm";
import { getAllApplicationScreen } from "../../CMSSlice";
import "react-toastify/dist/ReactToastify.css";

const ApplicationScreen = () => {
  const [applicationScreenDetails, setApplicationScreenDetails] = useState();
  const [isAddModalOpen, setIsAddModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState();
  const [deleteApplicationScreen, { isLoading: isDeleting }] =
    useDeleteMutation();
  const [pageSize, setPageSize] = useState(10);
  const [page, setPage] = useState(1);
  const [sort, setSort] = useState([]);
  const [globalSearchKeyword, setGlobalSearchKeyword] = useState(null);
  const [columnFilter, setColumnFilter] = useState({});
  const dispatch = useDispatch();
  const [
    getApplicationScreenRecords,
    {
      data: applicationScreenList,
      isError: isApplicationScreenError,
      isLoading: isApplicationScreenLoading,
      isFetching: isApplicationScreenFetching,
    },
  ] = useLazyGetRecordsQuery();

  const column = [
    {
      Header: "#",
      accessor: "Id",
      type: "Number",
    },
    {
      Header: "Application Name",
      accessor: "ApplicationDTO.Name",
      filter: true,
    },
    {
      Header: "Screen Name",
      accessor: "ScreenDTO.Name",
      filter: true,
    },
  ];

  const handleEditData = (applicationScreenData) => {
    setSelectedRecord(applicationScreenData);
    setIsAddModalOpen(true);
  };

  const handleDelete = () => {
    deleteApplicationScreen({
      entity: "CMS/ApplicationScreen",
      id: selectedRecord.Id,
      tag: APPLICATION_SCREEN_TAG,
    }).then((response) => {
      if (!response.error) {
        !isDeleting && setIsDeleteModalOpen(!isDeleteModalOpen);
        successToast("Application-screen deleted successfully.");
      }
    });
  };

  useEffect(() => {
    let { filterColumn, filterQuery } = formateColumnFilter(
      column,
      columnFilter
    );

    getApplicationScreenRecords({
      entity: "CMS/ApplicationScreens",
      entities: { Screen: {}, Application: {} },
      top: pageSize,
      skip: (page - 1) * pageSize,
      sort: sort,
      filter: filterQuery,
      globalFilter: {
        columns: filterColumn,
        globalSearchKeyword: globalSearchKeyword,
      },
      tag: APPLICATION_SCREEN_TAG,
    });
    setApplicationScreenDetails({ tableHeaderData: column, tableRowsData: [] });
    // eslint-disable-next-line
  }, [pageSize, page, sort, globalSearchKeyword, columnFilter]);

  useEffect(() => {
    if (
      !isApplicationScreenLoading &&
      !isApplicationScreenError &&
      applicationScreenList &&
      !isApplicationScreenFetching
    ) {
      dispatch(getAllApplicationScreen(applicationScreenList.value));
      let applicationScreenData = [...applicationScreenList.value];
      setApplicationScreenDetails({
        ...applicationScreenDetails,
        tableRowsData: applicationScreenList.value ? applicationScreenData : [],
        totalData:
          applicationScreenList && applicationScreenList["@odata.count"]
            ? applicationScreenList["@odata.count"]
            : 0,
        onEditClick: (data) => handleEditData(data),
        onDeleteClick: (data) => {
          setIsDeleteModalOpen(true);
          setSelectedRecord(data);
        },
      });
    }
    // eslint-disable-next-line
  }, [
    isApplicationScreenError,
    applicationScreenList,
    isApplicationScreenLoading,
    isApplicationScreenFetching,
  ]);

  return (
    <Container>
      <Row>
        {applicationScreenDetails && (
          <DataReactTable
            reactTableData={applicationScreenDetails}
            onAddClick={() => {
              setIsAddModalOpen(true);
              setSelectedRecord();
            }}
            title="Application Screen"
            isFetching={isApplicationScreenFetching}
            setPageNumber={setPage}
            recordsPerPage={pageSize}
            setRecordsPerPage={setPageSize}
            setSort={setSort}
            setGlobalSearchKeyword={setGlobalSearchKeyword}
            setColumnFilter={setColumnFilter}
          />
        )}
      </Row>
      {isAddModalOpen && (
        <AddModal
          toggle={() => setIsAddModalOpen(!isAddModalOpen)}
          color="success"
          title={`${selectedRecord ? "Edit" : "Add"} Application Screen`}
          header
          btn="Success"
          message={
            <ApplicationScreenForm
              editData={selectedRecord ? selectedRecord : {}}
              setIsAddModalOpen={setIsAddModalOpen}
            />
          }
        />
      )}
      {isDeleteModalOpen && (
        <Modal
          color="danger"
          title="Delete"
          message={`Are you sure you want to delete?`}
          handleOkClick={() => handleDelete()}
          toggle={() => setIsDeleteModalOpen(!isDeleteModalOpen)}
          isDeleting={isDeleting}
        />
      )}
    </Container>
  );
};

export default ApplicationScreen;
